import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBingoCarouselQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
  pageSlug: Types.Scalars['String']['input'];
  nowDate: Types.Scalars['String']['input'];
  nowTime: Types.Scalars['String']['input'];
}>;


export type GetBingoCarouselQuery = { __typename?: 'Query', pageData: Array<{ __typename?: 'Bingo', carouselData?: { __typename?: 'ItvHeroBannerCarousel', slides?: Array<{ __typename?: 'ItvHeroBannerCarousel_HeroBannerSlides', slideData?: { __typename?: 'HeroBannerSlides', hide_for_logged_in?: boolean | null, tag_id?: string | null, mobile_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, desktop_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'HeroBannerSlides_translations', title?: string | null, subtitle?: string | null, title_desktop?: string | null, subtitle_desktop?: string | null, title_mobile?: string | null, subtitle_mobile?: string | null, key_terms?: string | null, cta_text?: string | null, cta_link?: string | null, cta_open_in_new_tab?: boolean | null } | null> | null } | null } | null> | null } | null }> };


export const GetBingoCarouselDocument = gql`
    query GetBingoCarousel($language: String!, $pageSlug: String!, $nowDate: String!, $nowTime: String!) {
  pageData: Bingo(
    filter: {status: {_eq: "published"}, translations: {slug: {_eq: $pageSlug}}}
    limit: 1
  ) {
    carouselData: HeroBannerCarousel(filter: {status: {_eq: "published"}}) {
      slides(
        filter: {HeroBannerSlides_id: {status: {_eq: "published"}, _and: [{_or: [{start_at_date: {_null: true}}, {start_at_date: {_lt: $nowDate}}, {_and: [{start_at_date: {_eq: $nowDate}}, {_or: [{start_at_time: {_null: true}}, {start_at_time: {_lte: $nowTime}}]}]}]}, {_or: [{end_at_date: {_null: true}}, {end_at_date: {_gt: $nowDate}}, {_and: [{end_at_date: {_eq: $nowDate}}, {_or: [{end_at_time: {_null: true}}, {end_at_time: {_gte: $nowTime}}]}]}]}]}}
      ) {
        slideData: HeroBannerSlides_id {
          mobile_image {
            filename_disk
            width
            height
          }
          desktop_image {
            filename_disk
            width
            height
          }
          hide_for_logged_in
          tag_id
          translations(
            filter: {languages_language_code: {language_code: {_eq: $language}}}
          ) {
            title
            subtitle
            title_desktop
            subtitle_desktop
            title_mobile
            subtitle_mobile
            key_terms
            cta_text
            cta_link
            cta_open_in_new_tab
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBingoCarouselQuery__
 *
 * To run a query within a React component, call `useGetBingoCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBingoCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBingoCarouselQuery({
 *   variables: {
 *      language: // value for 'language'
 *      pageSlug: // value for 'pageSlug'
 *      nowDate: // value for 'nowDate'
 *      nowTime: // value for 'nowTime'
 *   },
 * });
 */
export function useGetBingoCarouselQuery(baseOptions: Apollo.QueryHookOptions<GetBingoCarouselQuery, GetBingoCarouselQueryVariables> & ({ variables: GetBingoCarouselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>(GetBingoCarouselDocument, options);
      }
export function useGetBingoCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>(GetBingoCarouselDocument, options);
        }
export function useGetBingoCarouselSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>(GetBingoCarouselDocument, options);
        }
export type GetBingoCarouselQueryHookResult = ReturnType<typeof useGetBingoCarouselQuery>;
export type GetBingoCarouselLazyQueryHookResult = ReturnType<typeof useGetBingoCarouselLazyQuery>;
export type GetBingoCarouselSuspenseQueryHookResult = ReturnType<typeof useGetBingoCarouselSuspenseQuery>;
export type GetBingoCarouselQueryResult = Apollo.QueryResult<GetBingoCarouselQuery, GetBingoCarouselQueryVariables>;